module.exports = __webpack_public_path__ + "static/media/pencil.f74123e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/pencil.svg
// module id = 912
// module chunks = 0